import { render } from "./AssignedDeviceV2.vue?vue&type=template&id=10f81b76&scoped=true"
import script from "./AssignedDeviceV2.vue?vue&type=script&lang=js"
export * from "./AssignedDeviceV2.vue?vue&type=script&lang=js"

import "./AssignedDeviceV2.vue?vue&type=style&index=0&id=10f81b76&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f81b76"]])

export default __exports__